import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useI18n } from './lib/i18n';
import { useSession } from './lib/queries';
import { TabBar } from './components/TabBar';
import { Logo, Spinner } from './components/ui';
import { AccessPage } from './pages/AccessPage';
import { WalletAccessPage } from './pages/WalletAccessPage';
import { CardPage } from './pages/CardPage';
import { GaragePage } from './pages/GaragePage';
import { HistoryPage } from './pages/HistoryPage';
import { LoginPage } from './pages/LoginPage';
import { ProfilePage } from './pages/ProfilePage';
import { RewardsPage } from './pages/RewardsPage';

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto min-h-dvh w-full max-w-md">
      <main className="px-4 pb-[calc(5.5rem+env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))]">
        {children}
      </main>
      <TabBar />
    </div>
  );
}

function Booting() {
  return (
    <div className="grid min-h-dvh place-items-center gap-6">
      <Logo size="lg" />
      <Spinner />
    </div>
  );
}

export function App() {
  const { t } = useI18n();
  const { data: session, isPending, error } = useSession();

  // The access link has to work before there is a session: it is what creates one.
  const isAccessRoute = window.location.pathname.startsWith('/access/');

  if (isPending && !isAccessRoute) return <Booting />;

  if (error && !isAccessRoute) {
    return (
      <div className="grid min-h-dvh place-items-center gap-4 px-8 text-center">
        <Logo size="lg" />
        <p className="text-sm text-ink-dim">{t('common.error')}</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/access/:token" element={<AccessPage />} />
        <Route path="/w/:token" element={<WalletAccessPage />} />
        {session ? (
          <>
            <Route path="/" element={<Shell><CardPage /></Shell>} />
            <Route path="/history" element={<Shell><HistoryPage /></Shell>} />
            <Route path="/rewards" element={<Shell><RewardsPage /></Shell>} />
            <Route path="/garage" element={<Shell><GaragePage /></Shell>} />
            <Route path="/profile" element={<Shell><ProfilePage /></Shell>} />
            <Route path="*" element={<Shell><CardPage /></Shell>} />
          </>
        ) : (
          <Route path="*" element={<LoginPage />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}
